import { promoCodeApi } from './promoCodeApi';
import { IValidatePromoCodeRequest, IValidatePromoCodeResponse } from './promoCodeTypes';

async function validatePromoCode(
  payload: IValidatePromoCodeRequest,
): Promise<IValidatePromoCodeResponse> {
  const response = await promoCodeApi.validatePromoCode(payload);
  return response;
}

export const promoCodeService = {
  validatePromoCode,
};
